import axios from "axios";
import React, { useEffect, useState } from "react";

const ProductCategory = () => {
  const [products, setProducts] = useState([]);
  const [loading] = useState(false);
  const [error] = useState(null);

  const storeId = "88026380";
  // const accessToken = "secret_tCeDaKfQgTEMUcKzrCpUdXJwU2N5nC8W";
  // const accessToken = "secret_kRcPTGe3QT5ra6F4Jn2mP9xwuGk2ZbCL";
  const accessToken = "secret_Jx3TRcj9PWcuhpjsygNwRfkpyUytxtDg";
  const [selectedCategoryId] = useState(null);

  useEffect(() => {
    let url = `https://app.ecwid.com/api/v3/${storeId}/products`;
    if (selectedCategoryId) {
      url += `?category=${selectedCategoryId}`;
    }

    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => setProducts(res.data.items))
      .catch((err) => console.error("Error fetching products:", err));
  }, [selectedCategoryId]);

  return (
    <section className="max-w-7xl mx-auto px-4 py-4 my-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold mb-4">Feature Products</h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Handpicked favorites that our customers love most
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {loading ? (
          <div className="flex items-center justify-center">
            <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-32 w-32"></div>
          </div>
        ) : error ? (
          <div className="text-center text-red-500 mb-4">{error.message}</div>
        ) : (
          products
            .map((product) => (
              <div
                key={product.id}
                className="flex flex-col items-center text-start p-4 border border-gray-300 hover:scale-105 transition-transform duration-300"
              >
                <img
                  src={product.imageUrl}
                  alt="Product"
                  className="w-64 h-64 mb-2 object-cover"
                />
                <h3 className="text-gray-600 text-xl font-bold">
                  {product.name}
                </h3>
                {/* <p className="text-gray-600">{product.description.slice(0,20)}</p> */}
                <div className="w-full flex items-center justify-between mt-4">
                  <h4 className="text-gray-600 text-2xl font-bold mt-2">
                    ${product.price}
                  </h4>
                  <button className="px-4 bg-gradient-to-r from-[#82b016] to-green-600 hover:from-[#6fa010] hover:to-green-700 text-white py-2 rounded-lg shadow-lg transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-xl">
                    Buy Now
                  </button>
                </div>
              </div>
            ))
            .slice(0, 8)
        )}
      </div>
    </section>
  );
};

export default ProductCategory;
